import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import CenterContent from '../Components/CenterContent/CenterContent'
import InstrumentsWrrapper from '../Components/InstrumentsWrrapper/InstrumentsWrrapper'
import { observer } from 'mobx-react-lite'
import { teacher } from '../store/teacherRep.ts'
import { student } from '../store/student.ts'
import ApplicationsExpect from './../block/applicationsTeacher/ApplicationsExpect'
import ApplicaionsDone from './../block/applicationsTeacher/ApplicationsDone'
import { reportTeacher } from './../store/reportTeacher'
import CheckBox from '../Components/CheckBox/CheckBox'
import http from './../Service/http'
import { direction } from '../store/direction'
import { IoMdThermometer } from 'react-icons/io'
import EmbassiesModal from '../Components/Modal/EmbassiesModal'
import SocialFundModal from '../Components/Modal/SocialFundModal'
import AboutLearningModal from '../Components/Modal/AboutLearningModal'
import AboutLearningModalKGMA from '../Components/Modal/AboutLearningModalKGMA'
// import BlueBtn from "../Components/SidBarButtons/BlueBtn";
// import Input from "react-select/dist/declarations/src/components/Input";
import { auth } from '../store/auth'
import { toast } from 'react-toastify'
import CallModal from '../Components/Modal/CallModal'
import SpravkaFinishingModal from '../Components/Modal/SpravkaFinishingModal'
import ReactPaginate from 'react-paginate'
import '../Styles/pagination.css'
import ArchiveModal from '../Components/Modal/ArchiveModal'
import AboutLearningResidentsModal from '../Components/Modal/AboutLearningResidentsModal'


export const ApplicationTeachContainer = observer(function () {
	const [form, setForm] = useState(false)
	const [embassies, setEmbassies] = useState(false)
	const [openSocial, setSocial] = useState(false)
	const [archive, setArchive] = useState(false)
	const [openLearn, setLearn] = useState(false)
	const { t, i18n } = useTranslation()
	const [isIspol, setIsIspol] = useState(false)
	const [currentPage, setCurrentPage] = useState(0);

	console.log("AUTH",auth)
    const ITEMS_PER_PAGE = 25;
    const handlePageChange = ({ selected }) => {
        setCurrentPage(selected);
    };

    const pageCount = Math.ceil(reportTeacher.reportExpected.length / ITEMS_PER_PAGE);

    const paginatedDisciplines = reportTeacher.reportExpected.slice(currentPage * ITEMS_PER_PAGE, (currentPage + 1) * ITEMS_PER_PAGE);

	const getReportsTeacher = async () => {
		const a = await http.post('/report/reportApplicationTeacher?reportType= ' + null)
		reportTeacher.newReportTeacher(a.data.reportApplicationTeacherWait)
	}

	// const getReportsTeacher = async (id) => {
	// 	const a = await http.post('/report/reportApplicationTeacher?reportType= ' + id)
	// 	reportTeacher.newReportTeacher(a.data.reportApplicationTeacherWait)
	// }

	useEffect(() => {
		getReportsTeacher(0)
	}, [])

	const openForm = () => {
		setForm(!form)
		setEmbassies(!embassies)
		setSocial(!openSocial)
		setArchive(!archive)
		setLearn(!openLearn)
	}

	const ispolnitelUpdate = async () => {
		const res = await http.post('/okno/ispolnitelStatus', {
			id_zakaz: student.student.id_okno_zakaz,
			AVN_operator: auth.user.data.id,
			doc: student.student.id_okno_document
		})
		if (res.data.result !== null) {
			toast(res.data.result)
			getReportsTeacher()
			setIsIspol(false)
		}
	}
	useEffect(() => {
		if (isIspol) {
			ispolnitelUpdate()
		}
	}, [isIspol])

	return (
		<CenterContent>
			<InstrumentsWrrapper
				leftHead={t('st:instrument.titles.appsExpected')}
				rightHead={t('st:instrument.titles.doneApps')}
				leftChilds={<ApplicationsExpect />}
				rightChilds={<ApplicaionsDone />}
			/>
			<div className='TableWrapper'>
				<table>
					<thead>
						<tr>
							<th style={{ width: '5%' }}>№sss</th>
							<th style={{ width: '35%', textAlign: 'left' }}>{t('st:table.fio')}</th>
							<th style={{ width: '15%' }}>{t('st:appTitle.titles.executor')}</th>
							<th style={{ width: '15%' }}>{t('st:appTitle.titles.jobTitle')}</th>
							<th style={{ width: '15%' }}>{t('st:appTitle.titles.doc')}</th>
							<th style={{ width: '10%', textAlign: 'center' }}>{t('st:appTitle.titles.number')}</th>
							<th style={{ width: '15%' }}>{t('st:appTitle.titles.type')}</th>
							<th style={{ width: '15%' }}>{t('st:appTitle.titles.dateApp')}</th>
							{direction.leftOrRight == 'left' ? (
								<th style={{ width: '10%' }}>{t('st:appTitle.titles.status')}</th>
							) : (
								<th style={{ width: '10%' }}>{t('st:appTitle.titles.doned')}</th>
							)}
							{direction.leftOrRight == 'left' ? (
								<th style={{ width: '10%' }}>{t('st:appTitle.titles.esp')}</th>
							) : (
								<th style={{ width: '10%' }}>{t('st:appTitle.titles.doned')}</th>
							)}
						</tr>
					</thead>
					<tbody>
						{paginatedDisciplines.map((item, index) => {
							return (
								<tr
									onClick={() => {
										teacher.newStudent(item)
									}}
								>
									<td>{index + 1 + currentPage * ITEMS_PER_PAGE}</td>
									<td style={{ textAlign: 'left' }}>{item.t_fio}</td>
									{item.status_new === false ? (
										<td onClick={() => setIsIspol(true)} style={{ color: '#2f80ed', fontWeight: 'bold' }}>
											{item.ispolnitel}
										</td>
									) : (
										<td>{item.ispolnitel}</td>
									)}
									<td>{item.post}</td>
									{item.status_new === true ? (
										<td onClick={openForm} style={{ color: '#2f80ed', fontWeight: 'bold' }}>
											{item.okno_document}
										</td>
									) : (
										<td>{item.okno_document}</td>
									)}
									<td>{item.reference_number}</td>

									<td>{item.status_online_offline}</td>
									<td>{item.date_insert}</td>

									{direction.leftOrRight == 'left' ? (
										<td
											style={{
												display: 'flex',
												justifyContent: 'center',
												alignItems: 'center'
											}}
										>
											{item.date_viewed ? (
												<CheckBox
													onchange={async e => {
														const res = await http.post('/report/reportApplicationUpdate', {
															id_okno_zakaz: item.id_okno_zakaz,
															id_okno_document: item.id_okno_document,
															status: 1
														})
														if (res.data.result === 'Заявка выполнено') {
															getReportsTeacher(reportTeacher.currentType)
														}
													}}
													checked={item.status === true ? true :false }
													item={item}
													active={true}
													dsbl={false}
													name=''
													styles={{ width: '17px' }}
												/>
											) : (
												<p className='new_report'>Новый</p>
											)}
										</td>
									) : (
										<td
											style={{
												display: 'flex',
												justifyContent: 'center',
												alignItems: 'center'
											}}
										>
											<p className='new_report' style={{ fontWeight: 400 }}>
												{item.date_viewed}
											</p>
										</td>
									)}

									{direction.leftOrRight == 'left' ? (
										<td
											style={{
												justifyContent: 'center',
												alignItems: 'center'
											}}
										>
											{item.date_viewed ? (
												<CheckBox
													onchange={async e => {
														const res = await http.post('/report/reportApplicationEdsUpdate', {
															id_okno_zakaz: item.id_okno_zakaz,
															id_okno_document: item.id_okno_document,
															status: 1,
															EDS: 1
														})
														if (res.data.result === 'Заявка отправлено на подпись') {
															getReportsTeacher(reportTeacher.currentType)
														}
													}}
													checked={item.EDS}
													item={item}
													active={true}
													dsbl={false}
													name=''
													styles={{ width: '17px' }}
												/>
											) : (
												<p className='new_report'>Новый</p>
											)}
										</td>
									) : (
										<td
											style={{
												marginLeft: "20px",
												justifyContent: 'center',
												alignItems: 'center'
											}}
										>
											<p className='new_report' style={{ fontWeight: 400 }}>
												{item.date_viewed}
											</p>
										</td>
									)}
								</tr>
							)
						})}
					</tbody>
				</table>
				{pageCount > 1 && (
                    <ReactPaginate
                        pageCount={pageCount}
                        marginPagesDisplayed={2}
                        pageRangeDisplayed={5}
                        onPageChange={handlePageChange}
                        containerClassName={'pagination'}
                        activeClassName={'active'}
                        previousLabel={'Previous'}
                        nextLabel={'Next'}
                        breakLabel={'...'}
                    />
                )}
				{student.student.id_okno_document === 10 ? embassies && <EmbassiesModal openForm={openForm} /> : null}
				{student.student.id_okno_document === 3 ? openSocial && <SocialFundModal openForm={openForm} /> : null}
				{student.student.id_okno_document === 4 ? openLearn && <AboutLearningModal openForm={openForm} /> : null}
				{student.student.id_okno_document === 13 ? openLearn && <AboutLearningModalKGMA openForm={openForm} /> : null}
				{student.student.id_okno_document === 9 ? openLearn && <CallModal openForm={openForm} /> : null}
				{student.student.id_okno_document === 5 ? openLearn && <SpravkaFinishingModal openForm={openForm} /> : null}
				{student.student.id_okno_document === 8 ? openLearn && <ArchiveModal openForm={openForm} /> : null}
				{student.student.id_okno_document === 12 ? openLearn && <AboutLearningResidentsModal openForm={openForm} /> : null}
				{student.student.id_okno_document !== 10 &&
					student.student.id_okno_document !== 3 &&
					student.student.id_okno_document !== 4 &&
					student.student.id_okno_document !== 13 &&
					student.student.id_okno_document !== 9 &&
					student.student.id_okno_document !== 8 &&
					student.student.id_okno_document !== 12 &&
					student.student.id_okno_document !== 5
						? form && <AboutLearningModal openForm={openForm} />
						: null}
			</div>
		</CenterContent>
	)
})
